import tw from 'tailwind-styled-components';
import styled from 'styled-components';

export const HeroContainer = tw.div`
  w-full
  overflow-x-hidden
`;

export const Background = styled.div<{ $customColor: string }>`
  position: relative;
  padding-bottom: 40px;
  ${({ $customColor }) =>
    $customColor ? `background-color: var(--color-primary,${$customColor});` : ''}
  overflow-x: hidden;
  z-index: -1;
`;
